<template>
  <div class="tin1">
    <navb :bgcolor="'transparent'" :title="type==1?'企业用户赠机票':'企业用户赠酒店'" @back="back" v-if="!isShowNonet"></navb>
    <navb title="满10赠1" :alwaysshow="true" @back="back"
      backarrow="//file.40017.cn/appresource/image/ec/icon_navi_back.png" v-else />
    <div class="bg-head" :style="{paddingTop:`${+statusHei+44}px`}">
      <img src="//file.40017.cn/appresource/image/tin1/bg_head.png?v=2">
    </div>
    <div class="head-box" v-if="status==1||status==0">
      <img class="icon-vip" src="//file.40017.cn/appresource/image/tin1/icon_co_vip.png?v=1">
      <template v-if="type==1">
        <img class="tit" src="//file.40017.cn/appresource/image/tin1/txt_tit_jp.png">
        <p class="desc">飞行10次赠免费机票</p>
        <!-- <div class="tic-box">
          <p class="tic-tit">2022年免费机票1张</p>
          <p class="tic-cost">最高价值1000元</p>
          <p class="tic-exp">领取任务并完成后2022年内可用</p>
          <img class="tic-icon" src="//file.40017.cn/appresource/image/tin1/icon_airplane.png">
        </div> -->
      </template>
      <template v-else>
        <img class="tit" src="//file.40017.cn/appresource/image/tin1/txt_tit_jd.png">
        <p class="desc">入住10次赠免费酒店</p>
        <!-- <div class="tic-box">
          <p class="tic-tit">2022年免费酒店1次</p>
          <p class="tic-cost">最高价值1000元</p>
          <p class="tic-exp">领取任务并完成后2022年内可用</p>
          <img class="tic-icon" src="//file.40017.cn/appresource/image/tin1/icon_hotel.png"> <img class="tic-icon"
            src="//file.40017.cn/appresource/image/tin1/icon_airplane.png">
        </div> -->
      </template>
      <img class="head-card" :src="headImg">
    </div>
    <template v-else>
      <div class="task-box">
        <img class="tit" v-if="type==1" src="//file.40017.cn/appresource/image/tin1/txt_tit_jp.png">
        <img class="tit" v-else src="//file.40017.cn/appresource/image/tin1/txt_tit_jd.png">
        <img class="icon-vip" src="//file.40017.cn/appresource/image/tin1/icon_co_vip.png?v=1">
        <p class="desc" v-if="type==1">飞行10次赠免费机票</p>
        <p class="desc" v-else>入住10次赠免费酒店</p>
        <div class="task-panel">
          <p class="task-tit">任务进度</p>
          <p class="task-desc" @click="toDetail">
            {{type=='1'?'飞行':'入住'}}次数<span>{{currentCount}}</span>次，当前总金额<span>￥{{sum}}</span><img class="right-arr"
              src="//file.40017.cn/appresource/image/tin1/icon_arrow_right.png"></p>
          <ul class="combo-list">
            <template v-if="type==1">
              <li class="combo" v-for="i in 10" :key="i">
                <img class="img" v-if="orderDetailList.length>=i"
                  src="//file.40017.cn/appresource/image/tin1/icon_airplane_blue.png">
                <img class="img" v-else src="//file.40017.cn/appresource/image/tin1/icon_airplane_gray.png">
              </li>
            </template>
            <template v-else>
              <li class="combo" v-for="i in 10" :key="i">
                <img class="img" v-if="orderDetailList.length>=i"
                  src="//file.40017.cn/appresource/image/tin1/icon_hotel_blue.png">
                <img class="img" v-else src="//file.40017.cn/appresource/image/tin1/icon_hotel_gray.png">
              </li>
            </template>
          </ul>
        </div>
      </div>
      <div class="bonus-box" v-if="subTaskList.length>0">
        <p class="bonus-tit">活动奖励</p>
        <div class="roll-box">
          <ul class="bonus-list">
            <div class="suspend" :class="{first:progress==0,last:progress==100}" :style="{left:progress+'%'}">
              {{type=='1'?'飞行':'入住'}}{{currentCount}}次，平均金额¥{{avg}}</div>
            <ul class="progress-box">
              <li class="progress" :style="{width:progress+'%'}"></li>
            </ul>
            <li class="bonus" v-for="(item,i) in subTaskList" :key="i">
              <p class="round" :class="{light:i<=idx}"></p>
              <div class="bonus-card" :class="{light:i==idx}">
                <img class="bg" v-if="i==idx" src="//file.40017.cn/appresource/image/tin1/bg_coupon_blue.png?v=2">
                <img class="bg" v-else src="//file.40017.cn/appresource/image/tin1/bg_coupon_gray.png?v=2">
                <div class="pos">
                  <p class="price">{{item.rightsAmount}}元<br>免费{{type==1?'机票':'酒店'}}</p>
                  <p class="range">{{item.rightsAmount}}以内可用</p>
                </div>
              </div>
            </li>
          </ul>
          <div class="pad"></div>
        </div>
      </div>
    </template>
    <p class="rule-tit">活动规则</p>
    <div class="rule-content" v-html="rule"></div>

    <div class="btn-get" v-if="status==0" @click="toCoAuth">
      <p class="top">前往企业认证</p>
    </div>
    <div class="btn-get dis" v-else-if="authCount<5&&type==2">
      <p class="top">企业满5人可开启</p>
    </div>
    <div class="btn-get" v-else-if="status==1" @click="getTask">
      <p class="top">领取任务</p>
    </div>
    <div class="btn-get" v-else-if="status==2" @click="toOrder(1)">
      <p class="top">立即预订{{type==1?'机票':'酒店'}}</p>
    </div>
    <div class="btn-get" v-else-if="status==3" @click="getRight">
      <p class="top">领取权益</p>
    </div>
    <div class="btn-get" v-else-if="status==4" @click="toOrder(2)">
      <p class="top">去使用</p>
      <p class="btm">权益领取后30天内有效</p>
    </div>
    <div class="btn-get dis" v-else-if="status==5">
      <p class="top">已使用</p>
      <p class="btm">本期任务已结束，更多权益请期待</p>
    </div>
    <div class="btn-get dis" v-else-if="status==6||status==7">
      <p class="top">权益已过期</p>
      <p class="btm">本期任务已结束，更多权益请期待</p>
    </div>
    <div class="btn-get dis" v-else>
      <p class="top">任务已过期</p>
      <p class="btm">本期任务已结束，更多权益请期待</p>
    </div>
    <present v-show="isShowPresent" :info="bonusInfo" @close="onPresent" />
    <hint v-show="isShowHint" @handler="onHintAction" :hintinfo="hintInfo" />
    <get v-show="isShowGet" @use="toOrder(2)" :price="nowRightPrice" :type="type" @close="isShowGet=false" />
    <nonet v-if="isShowNonet" />
  </div>
</template>
<script>
import navb from "./components/nav"
import present from "./components/present"
import hint from "./components/hint"
import get from "./components/get"
import nonet from "./components/netError"
import { getTaskStatus, openTask, receiveRight, getRightInfo, tianyanCode } from "@/api/tin1"

const toPage = (jumpUrl) => {
  if (jumpUrl.indexOf("/") == 0) {
    jumpUrl = location.href.substr(0, location.href.lastIndexOf("/")) + jumpUrl;
  }
  window._tc_bridge_web.open_newurl({
    param: {
      openParams: "newWindow,needSlide",
      jumpUrl,
    },
  });
};
const toast = txt => {
  window._tc_bridge_util.show_toast({
    param: {
      showInfo: txt,
    },
  });
}
//事件埋点
const setEvent = (eventInfo) => {
  const { category = 'qiye-rights', action = '', label = '', value = '', pagename = '满10赠1' } = eventInfo
  console.log(value)
  setTimeout(() => {
    window._tc_bridge_util.set_category_event({
      "param": {
        category,
        action,
        optLabel: label,
        optValue: value,
        pagename
      }
    })
  }, 0)
}
const getStatusTxt = status => {
  let txt = ''
  //未认证/未开始/进行中/已过期/已领取权益/已使用权益/已完成
  switch (+status) {
    case 0:
      txt = '未认证'
      break
    case 1:
      txt = '未开始'
      break
    case 2:
      txt = '进行中'
      break
    case 3:
      txt = '已完成'
      break
    case 4:
      txt = '已领取权益'
      break
    case 5:
      txt = '已使用权益'
      break
    case 6:
      txt = '权益已过期'
      break
    default:
      txt = '任务已过期'
      break
  }
  return txt
}
let userKey = '', activityCode, taskId, product = '', memberId = ''
export default {
  components: { navb, present, hint, get, nonet },
  data() {
    return {
      statusHei: 0,
      now: 2000,
      idx: -1,
      progress: 0,
      isShowPresent: false,
      isShowHint: false,
      isShowGet: false,
      isShowNonet: false,
      type: this.$route.query.type || '1',
      status: 1,
      subTaskList: [],
      orderDetailList: [],
      currentCount: 0,
      sum: 0,
      avg: 0,
      hintInfo: "{}",
      nowRightPrice: 0,
      nickName: '',
      bonusInfo: "{}",
      rule: '',
      authCount: 0,
      headImg: ''
    }
  },
  created() {
    const that = this
    // this.$loading.show()
    activityCode = this.$route.query.code || ''
    product = this.type == 1 ? '机票' : '酒店'
    console.log(this.idx)
    _multi_bridge_ready(() => {
      window._tc_bridge_user.get_device_info({
        param: {},
        callback: function (data) {
          const dbody = JSON.parse(data.CBData);
          const deviceInfo = dbody.deviceInfo;
          console.log(deviceInfo);
          if (window._tc_bridge_public.platform == 1) {
            //安卓
            that.statusHei = deviceInfo.statusBarHeightPx / 3;
          } else {
            that.statusHei = deviceInfo.statusBarHeightPx;
          }
        },
      });
      window._tc_bridge_user.user_login({
        callback: (res) => {
          const data = JSON.parse(res.CBData);
          console.log(data);
          userKey = data.memberInfo.securityToken
          memberId = data.memberInfo.mobile
          this.nickName = data.memberInfo.nickName
          if (userKey) {
            this.getInfo().then(() => {
              setEvent({
                action: 'qiye-page-show',
                label: '满10赠1页面曝光',
                value: JSON.stringify({ "scene": getStatusTxt(this.status), product })
              })
            })
          } else {
            window._tc_bridge_util.set_webview_back()
          }
        }
      })
    })

  },
  methods: {
    onPresent(bool) {
      this.isShowPresent = false
      setEvent({
        action: 'dialog_click',
        label: '订单顺延弹窗点击',
        value: JSON.stringify({ "product": product, "scene": bool ? '领取' : '查看' })
      })
    },
    toCoAuth() {
      toPage(`${location.origin}/certification/ecindex?wvc6=1&tcwvclogin`)
    },
    getTask() {
      this.$loading.show({ type: 'part' });
      openTask({
        tianyanCode,
        activityCode,
        projectId: this.type,
        source: '1',
        userKey
      }).then(res => {
        if (res.code == '0') {
          // res.data.flightOrderType = 1
          // if (res.data.flightOrderType == 1) {
          //   this.getInfo(true).then(() => {
          //     console.log(this.orderDetailList)
          //     if (this.orderDetailList.length > 0) {
          //       this.isShowPresent = true
          //       setEvent({
          //         action: 'qiye-pop-show',
          //         label: '赠送1次弹窗展示'
          //       })
          //     }
          //   })
          // } else {
          this.getInfo(true)
          // }
          if (this.orderCountFor2022 < 1) {
            toast('领取成功')
          }

        } else {
          this.$loading.hide()
          toast(res.msg)
        }

        setEvent({
          action: 'qiye-click',
          label: '点击领取任务',
          value: JSON.stringify({ "scene": "未开始", product, "result": res.code == 0 ? '成功' : '失败' })
        })
      })
    },
    getInfo(bool) {
      return new Promise(resolve => {
        getTaskStatus({
          projectId: this.type,
          tianyanCode,
          activityCode,
          source: '1',
          userKey
        }).then(res => {
          console.log(res)
          this.$loading.hide()
          if (res.code == '0') {
            this.status = res.data.status

            /*********** 测试代码 ************/
            // this.status = 2
            // bool = true
            // res.data.orderDetail = [{ amount: 800 },{ amount: 800 },{ amount: 800 },{ amount: 800 },{ amount: 800 }, { amount: 1000 }, { amount: 1000 }, { amount: 1000 }, { amount: 1000 }, { amount: 1000 }, { amount: 1000 }]
            // res.data.orderCountFor2022 = 3
            /*********** 测试代码 ************/

            this.headImg = res.data.firstFigureUrl

            this.authCount = res.data.authCount

            taskId = res.data.taskId
            if (res.data.rightInfo && res.data.rightInfo.rightDesc)
              this.rule = res.data.rightInfo.rightDesc || ''




            if (this.status != 1 && this.status != 0) {
              let subTaskList = []
              if (res.data.rightInfo.list && res.data.rightInfo.list.length > 0 && res.data.subTaskList && res.data.subTaskList.length > 0) {
                res.data.rightInfo.list.forEach(right => {
                  const stepArr = res.data.subTaskList.filter(item => {
                    return item.stepSort == right.taskStepSort && right.taskProjectType == this.type
                  })
                  if (stepArr.length > 0) {
                    subTaskList.push({
                      accAmountMin: stepArr[0].accAmountMin,
                      stepSort: right.taskStepSort,
                      rightsAmount: right.rightsAmount
                    })
                  }
                })
              }

              if (subTaskList.length > 0) {
                subTaskList.sort((now, next) => {
                  if (+now.accAmountMin < +next.accAmountMin) return 1
                  else if (+now.accAmountMin > +next.accAmountMin) return 0
                  else return 0
                })
              }


              this.subTaskList = subTaskList
              this.orderDetailList = res.data.orderDetail || []
              this.currentCount = res.data.currentCount > 10 ? 10 : res.data.currentCount
              this.orderCountFor2022 = +res.data.orderCountFor2022 || 0
              this.bonusInfo = JSON.stringify({
                orderCountFor2022: this.orderCountFor2022,
                orderLen: this.orderDetailList.length,
                type: this.type,
                status: this.status,
                isOpen: bool
              })
              /*********** 测试代码 ************/
              // this.currentCount = 10
              // this.subTaskList = [{ accAmountMin: 200 }, { accAmountMin: 700 }, { accAmountMin: 1001 },]
              /*********** 测试代码 ************/


              if (this.orderDetailList.length > 0) {
                let sum = 0

                const len = this.orderDetailList.length

                for (let i = 0; i < this.currentCount; i++) {
                  let item = this.orderDetailList[i]
                  sum += +item.amount
                }
                this.sum = sum
                this.avg = Math.round(sum / this.currentCount)
                if ((this.status == 2 || this.status == 3) && this.orderCountFor2022 && localStorage.tin1_has_2022_order != `${memberId}_${activityCode}`) {
                  localStorage.tin1_has_2022_order = `${memberId}_${activityCode}`
                  this.isShowPresent = true

                  setEvent({
                    action: 'dialog_show',
                    label: '订单顺延弹窗曝光',
                    value: JSON.stringify({ "product": product, "scene": bool ? '领取' : '查看' })
                  })
                }
              } else {
                this.avg = 0
                this.sum = 0
              }
              let pgs = 0, idx = -1
              const len = this.subTaskList.length
              if (len > 0) {
                if (this.avg < +this.subTaskList[0].accAmountMin) {
                  pgs = 0
                  idx = -1
                } else {
                  for (let i = 0; i < len; i++) {
                    if (this.avg >= +this.subTaskList[i].accAmountMin) {
                      pgs = (i + 1) / len * 100
                      idx = i
                    }
                  }
                }
              }
              this.progress = pgs
              this.idx = idx
            }
          } else {
            if (!bool) this.isShowNonet = true
          }
          resolve()
        })
      })
    },
    getRight(bool = true) {
      let allthanstep = true, sum = 0, nextStepPriceAll = 0, nextStepPrice, nowStepPrice, nextRightPrice
      this.nowRightPrice = +this.subTaskList[this.idx].rightsAmount
      if (this.idx < this.subTaskList.length - 1) {
        //后边还有阶梯
        //平均值判断，弹窗或者直接领取
        //促11单：当用户最近9单均实付价超过当前档位时，弹窗提醒用户是否尝试第11单。
        const len = this.orderDetailList.length
        nowStepPrice = +this.subTaskList[this.idx].accAmountMin
        for (let i = 0; i < 9; i++) {
          const oprice = +this.orderDetailList[len - 1 - i].amount
          if (oprice < nowStepPrice) {
            allthanstep = false
            break
          } else {
            sum += oprice
          }
        }
        nextStepPrice = +this.subTaskList[this.idx + 1].accAmountMin
        nextRightPrice = +this.subTaskList[this.idx + 1].rightsAmount
        nextStepPriceAll = nextStepPrice * 10
        console.log(allthanstep)
      } else {
        allthanstep = false
      }
      if (bool && allthanstep) {
        this.hintInfo = JSON.stringify({
          now: this.nowRightPrice,
          next: nextRightPrice,
          spread: nextStepPriceAll - sum,
        })
        console.log(this.hintInfo)
        this.isShowHint = true
        setEvent({
          action: 'qiye-popshow',
          label: '第11单引导弹窗展示',
          value: JSON.stringify({ product })
        })
      } else {
        this.$loading.show({ type: 'part' });
        receiveRight({
          projectId: this.type,
          tianyanCode,
          activityCode,
          source: '1',
          taskStep: this.subTaskList[this.idx].stepSort,
          taskId,
          userKey
        }).then(res => {
          console.log(res)
          this.$loading.hide()
          if (res.code == '0') {
            this.isShowGet = true
            this.isShowHint = false
            this.getInfo()
          } else {
            toast(res.msg)
          }
        }).catch(() => {
          this.$loading.hide()
        })
      }
    },
    onHintAction(type) {
      if (type == 1) {
        this.getRight(false)
        setEvent({
          action: 'qiye-click',
          label: '第11单引导弹窗点击',
          value: JSON.stringify({ product, button: '直接兑换' })
        })
      } else if (type == 2) {
        this.toOrder(3)
      } else {
        this.isShowHint = false
      }
    },
    toOrder(type) {
      if (this.type == 1) {
        location.href = 'eltclient://app/home?tab=main&project=flight'
      } else {
        location.href = "eltclient://app/home?tab=main&project=hotel"
      }
      if (type == 1) {
        setEvent({
          action: 'qiye-click',
          label: '点击立即预定',
          value: JSON.stringify({ "scene": "进行中", product })
        })
      } else if (type == 2) {
        setEvent({
          action: 'qiye-click',
          label: '已领取权益',
          value: JSON.stringify({ "scene": "进行中", product })
        })
      } else {
        setEvent({
          action: 'qiye-click',
          label: '第11单引导弹窗点击',
          value: JSON.stringify({ product, button: '再来一单' })
        })
      }
    },
    toDetail() {
      toPage(`/detail?wvc6=1&type=${this.type}&code=${activityCode}`)
      setEvent({
        action: 'qiye-click',
        label: '点击明细',
        value: JSON.stringify({ "scene": getStatusTxt(this.status), product })
      })
    },
    back() {
      window._tc_bridge_util.set_webview_back()
    }
  }
}
</script>
<style lang="less" scoped src="./css/index.less"></style>
<style>
.rule-content img {
  width: 100%;
  height: auto;
  margin: 11px 0;
}
</style>